(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('ItemSelectionService', ItemSelectionServiceFactory);

  ItemSelectionServiceFactory.$inject = [
    '$uibModal',
    '$q'
  ];

  // eslint-disable-next-line max-lines-per-function
  function ItemSelectionServiceFactory($uibModal, $q) {
    const service = {
      open,
      findSelected
    };
    let primaryKey;
    let descriptionKey;
    return service;

    //////////////////////////////////////////
    // Function declarations

    function open(items, itemName, options) {
      options = (options || {});
      primaryKey = options.primaryKey || 'id';
      descriptionKey = options.descriptionKey || 'descricao';

      const modal = $uibModal.open({
        controller: 'ItemSelectionModalCtrl',
        controllerAs: 'ctrl',
        resolve: {
          items: () => items,
          itemName: () => itemName,
          allowMultiple: () => options.allowMultiple,
          primaryKey: () => primaryKey,
          descriptionKey: () => descriptionKey
        },
        templateUrl: 'views/_item-selection-modal.html'
      });

      return modal.result;
    }

    function findSelected(list, selected) {
      return (selected || []).map((prod) => _.find(list, {
        id: prod.item_id || prod.item_codigo || prod.id || prod.cd_item
      }));
    }
  }
}());
